import Ajax from 'global/od/Ajax';

const liveChat = () => {
	const chatButton = document.getElementById('liveChat');

	if (chatButton) {
		openToWindow(chatButton);
	}
};

const liveChatViaData = () => {
	document.querySelectorAll('[data-id="liveChat"]').forEach(openToWindow);
};

function openToWindow(chatButton) {
	chatButton.addEventListener('click', e => {
		e.preventDefault();

		const liveChatUrl = chatButton.getAttribute('href');
		const liveChatTitle = chatButton.getAttribute('title');
		logErrorToServer(chatButton);
		window.open(
			liveChatUrl,
			liveChatTitle,
			'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,width=560,height=840',
		);
	});
}

function logErrorToServer(chatButton) {
	Ajax.post('/ajax/logjserror', {
		message: `errorType: getting the liveChat url,date: ${new Date()},customerID: ${
			window.dataLayer[0].userInfo.customerID || undefined
		},chaturl: ${chatButton.getAttribute('href')},vikingOneUser: ${
			window.dataLayer[0].userInfo.vikingOneUser
		}`,
		lineNumber: 19,
		url: 'liveChat.js',
	});
}

export { liveChat, liveChatViaData };
